import React, { useEffect, useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import { createProduct, fetchProducts, fetchCategories, createCategory } from '../api';

const ProductForm = ({ setProducts }) => {
  const [name, setName] = useState('');
  const [nameByket, setNameByket] = useState('');
  const [price, setPrice] = useState('');
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');

  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');

  // Храним base64-картинку
  const [imageBase64, setImageBase64] = useState('');

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await fetchCategories();
        setCategories(data);
      } catch (error) {
        console.error('Не вдалося завантажити категорії:', error);
      }
    };
    loadCategories();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setImageBase64('');
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageBase64(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createProduct({
        name,
        name_byket: nameByket,
        price,
        category_id: selectedCategory,
        image: imageBase64,
      });

      const products = await fetchProducts();
      setProducts(products);

      setName('');
      setNameByket('');
      setPrice('');
      setSelectedCategory('');
      setImageBase64('');
    } catch (error) {
      console.error('Не вдалося додати продукт:', error);
    }
  };

  const handleAddCategory = async () => {
    try {
      const newCategory = await createCategory({ name: newCategoryName });
      setCategories([...categories, newCategory]);
      setNewCategoryName('');
      setShowCategoryModal(false);
    } catch (error) {
      console.error('Не вдалося додати категорію:', error);
    }
  };

  return (
    <div>
      <Form onSubmit={handleSubmit} className="mt-3">
        {/* Поле "Назва" */}
        <Form.Group className="mb-3">
          <Form.Label>Комірка</Form.Label>
          <Form.Control
            type="text"
            placeholder="Введіть назву"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Form.Group>

        {/* Поле "Назва букета" */}
        <Form.Group className="mb-3">
          <Form.Label>Назва букета</Form.Label>
          <Form.Control
            type="text"
            placeholder="Введіть назву букета"
            value={nameByket}
            onChange={(e) => setNameByket(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Ціна</Form.Label>
          <Form.Control
            type="number"
            placeholder="Введіть ціну"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Категорія</Form.Label>
          <Form.Select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            required
          >
            <option value="">Оберіть категорію</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </Form.Select>
          <Button variant="link" onClick={() => setShowCategoryModal(true)}>
            Додати нову категорію
          </Button>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Зображення (Base64)</Form.Label>
          <Form.Control type="file" onChange={handleFileChange} />
        </Form.Group>

        <Button type="submit">Додати продукт</Button>
      </Form>

      <Modal show={showCategoryModal} onHide={() => setShowCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Додати категорію</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Назва категорії</Form.Label>
            <Form.Control
              type="text"
              placeholder="Введіть назву категорії"
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCategoryModal(false)}>
            Закрити
          </Button>
          <Button variant="primary" onClick={handleAddCategory}>
            Додати
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProductForm;
